import React from 'react';
import { firebaseRoot } from './../../utils/firebase-utils';
import Modal from 'react-bootstrap/lib/Modal';
import TouchButton from '..//TouchButton';
import TouchLink from '../TouchLink';
import classNames from 'classnames';
import filepickerLibrary from 'filepicker-js';

import Glyphicon from 'react-bootstrap/lib/Glyphicon';

const ImagePickerModal = React.createClass({
	onClickAvatar(avatarClassName) {
		this.props.handleClickAvatar(avatarClassName);
	},
    handleOnClickAdd() {
        this.props.handleOnClickAdd();
    },
	render() {
		return(
			<Modal
				{...this.props}
				bsSize="large"
			>
				<Modal.Body>
					<h3>Select avatar</h3>
					<div className="avatars">
						<div className="avatar albert-1" onClick={this.onClickAvatar.bind(this, "albert-1")}></div>
						<div className="avatar albert-2" onClick={this.onClickAvatar.bind(this, "albert-2")}></div>
						<div className="avatar albert-3" onClick={this.onClickAvatar.bind(this, "albert-3")}></div>
						<div className="avatar albert-4" onClick={this.onClickAvatar.bind(this, "albert-4")}></div>
						<div className="avatar albert-5" onClick={this.onClickAvatar.bind(this, "albert-5")}></div>
						<div className="avatar avatar-upload-wrap">
							<div className="avatar-upload">
								<span className="text"><Glyphicon glyph="plus"/></span>
								<input className="input"  accepet="image/*" capture="camera" onClick={this.handleOnClickAdd}/>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<TouchButton bsStyle="primary" onClick={this.props.onHide}>Cancel</TouchButton>
				</Modal.Footer>
			</Modal>
		)
	}
});

const ImagePicker = React.createClass({

	getInitialState() {
		return {
			modalVisible: false
		}
	},

    contextTypes: {
        userRef: React.PropTypes.object
    },

	showModal() {
		this.setState({
            modalVisible: true
		});
	},

    hideModal() {
        this.setState({
            modalVisible: false
        });
    },

	render() {
		return(
			<div className="image-picker-wrap">
                {
					(this.context.userRef.val().avatar)?
						(this.context.userRef.val().avatar.startsWith('albert'))
							? <div className={'image-picker-selector avatar '+ this.context.userRef.val().avatar} onClick={this.showModal} ></div>
							: <div className="image-picker-selector" onClick={this.showModal} > <img src={this.context.userRef.val().avatar} alt="avatar image"/></div>
					:<div className="image-picker-selector" onClick={this.showModal}></div>
                }
				<ImagePickerModal
					show={this.state.modalVisible}
				    onHide={this.hideModal}
					handleClickAvatar={this.saveAvatar}
                    handleOnClickAdd={this.handleOnClickAdd}
				/>
			</div>
		);
	},

    saveAvatar(clickedAvatarClass) {
        this.context.userRef.ref().child("avatar").set(clickedAvatarClass).then(
            this.hideModal(), window.alert
        );
    },

    handleOnClickAdd() {
        this.hideModal();
        firebaseRoot.child('admin/settings/filestackKey').once('value').then(key => {
            filepicker.setKey(key.val());
            filepicker.pick(
                (link) => {
                    this.context.userRef.ref().child("avatar").set(link.url);
                }
            );
        }, window.alert);


    }
});

export default ImagePicker;



/** WEBPACK FOOTER **
 ** ./src/components/ImagePicker/ImagePicker.js
 **/